import { readStorage, writeStorage } from "./storage";

/**
 * Workspace ids this browser has opened. The API has no "list my workspaces" route yet, so
 * the switcher offers these. A per-viewer convenience, never a source of truth.
 */
const KEY = "goalhorns.recentWorkspaces";
const MAX_RECENT = 10;

export function readRecentWorkspaces(): string[] {
  const raw = readStorage(KEY);
  if (!raw) return [];
  try {
    const value: unknown = JSON.parse(raw);
    return Array.isArray(value) ? value.filter((id): id is string => typeof id === "string") : [];
  } catch {
    return [];
  }
}

/** Returns the new list with `workspaceId` first; the input is not mutated. */
export function rememberWorkspace(workspaceId: string): string[] {
  const next = [workspaceId, ...readRecentWorkspaces().filter((id) => id !== workspaceId)].slice(
    0,
    MAX_RECENT,
  );
  writeStorage(KEY, JSON.stringify(next));
  return next;
}

/** Drops a workspace id from this browser's memory, e.g. one that no longer opens. */
export function forgetWorkspace(workspaceId: string): string[] {
  const next = readRecentWorkspaces().filter((id) => id !== workspaceId);
  writeStorage(KEY, JSON.stringify(next));
  return next;
}
